<template>
  <a-modal
    title="增减明细总览"
    :width="hideModalWidth"
    centered
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-row :gutter="8" style="margin-bottom: 16px">
      <a-col :span="6">
        <a-input
          placeholder="请输入学生姓名"
          class="filter-selection"
          allow-clear
          v-model="searchForm.studentName"
        />
      </a-col>
      <a-col :span="6">
        <a-input
          placeholder="请输入学生手机号"
          class="filter-selection"
          allow-clear
          v-model="searchForm.phoneNumber"
        />
      </a-col>
      <a-col :span="6">
        <a-input
          placeholder="请输入操作人姓名"
          class="filter-selection"
          allow-clear
          v-model="searchForm.operateName"
        />
      </a-col>
      <a-col :span="6" style="text-align: right">
        <template>
          <a-button type="primary" @click="search" style="margin-right: 8px;">
            搜索
          </a-button>
        </template>
        <template>
          <a-button @click="reset" class="ant-btn-secondary">
            重置
          </a-button>
        </template>
      </a-col>
    </a-row>
    <a-table
      row-key="id"
      :scroll="scroll"
      :loading="tableLoading"
      :columns="columns"
      :data-source="studentList"
      :pagination="false"
    >
      <div slot="operateTime" slot-scope="text">
        {{ text | formatTimeStr }}
      </div>
      <div slot="coinsNum" slot-scope="text">
        {{ text > 0 ? `+${text}` : text }}
      </div>
    </a-table>
    <div class="pagination">
      <a-pagination
        v-show="pagination.total > 0"
        v-model="pagination.current"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @change="handleChangePageNum"
      />
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
const columns = [
  {
    title: '姓名',
    dataIndex: 'userName'
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber'
  },
  {
    title: '增减金币',
    dataIndex: 'coinsNum',
    scopedSlots: { customRender: 'coinsNum' }
  },
  {
    title: '操作人',
    dataIndex: 'operateName'
  },
  {
    title: '操作时间',
    dataIndex: 'operateTime',
    scopedSlots: { customRender: 'operateTime' }
  }
]

export default {
  name: 'OverView',

  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    formatTimeStr(record) {
      return record && `${moment(record).format('YYYY.MM.DD HH:mm:ss')}`
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.pagination.current = 1
        this.getList()
      }
    }
  },

  data() {
    return {
      columns,
      tableLoading: false,
      studentList: [],
      searchForm: {
        studentName: undefined,
        phoneNumber: undefined,
        operateName: undefined
      },
      pagination: {
        pageSize: 50,
        total: 0,
        current: 1
      },
      scroll: {
        x: 760,
        y: 'calc(100vh - 80px - 54px - 74px - 57px - 68px )'
      },
      hideModalWidth: 880
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize() {
      const w = document.documentElement.clientWidth || document.body.clientWidth
      if (w > 1024) {
        this.hideModalWidth = 880
      } else {
        this.hideModalWidth = 'calc(100% - 80px)'
      }
    },
    search() {
      this.pagination.current = 1
      this.getList()
    },
    reset() {
      Object.keys(this.searchForm).forEach(k => {
        this.searchForm[k] = undefined
      })
      this.search()
    },
    getList() {
      this.tableLoading = true
      const searchParams = {
        ...this.searchForm,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current
      }
      this.$service.coin.getAllCoinsPage(searchParams).then(res => {
        this.tableLoading = false
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        this.studentList = res.list
      }).catch(err => {
        this.tableLoading = false
      }).finally(() => {
        this.tableLoading = false
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
    handleChangePageNum(current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-modal-body) {
  padding-bottom: 20px;
}
.pagination {
  text-align: right;
  padding-top: 20px;
}
</style>